import { selectCurrentLanguage } from '@helsenorge/framework-utils/language';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { HNeventOpenHjelpeskuff } from '../../events';
import { openHjelpeskuff as openHjelpeskuffAction } from '../hjelpeskuff';
/**
 * Hent custom hjelpetekst for en tjeneste
 * @param tjenesteNavn Navn på tjenesten
 * @param hjelpetekstId Id til hjelpeteksten
 * @param useCustomEvent Dersom hjelpekomponenten brukes i microweb, må hjelpeskuffen åpnes med et custom event
 */
const useCustomHjelpetekstById = (tjenesteNavn, hjelpetekstId, useCustomEvent = false) => {
    const dispatch = useAppDispatch();
    const language = useAppSelector(state => selectCurrentLanguage(state.language));
    const customHjelpetekst = useAppSelector(state => state.prosesshjelp.customHjelpetekster[`${tjenesteNavn}.${language}`]);
    let hjelpetekst;
    if (Array.isArray(hjelpetekstId)) {
        hjelpetekst = customHjelpetekst?.hjelpetekster.find(tekst => hjelpetekstId.includes(tekst.id));
    }
    else {
        hjelpetekst = customHjelpetekst?.hjelpetekster.find(hjelpetekst => hjelpetekst.id === hjelpetekstId);
    }
    const openHjelpeskuff = () => {
        if (!hjelpetekst?.hjelpeskuffTittel || !hjelpetekst?.hjelpeskuffTekst) {
            return;
        }
        if (useCustomEvent) {
            HNeventOpenHjelpeskuff({ tjenesteNavn, hjelpetekstId, language });
        }
        else {
            dispatch(openHjelpeskuffAction({
                hjelpeskuffTittel: hjelpetekst.hjelpeskuffTittel,
                hjelpeskuffTekst: hjelpetekst.hjelpeskuffTekst,
            }));
        }
    };
    return {
        hjelpetekst,
        openHjelpeskuff,
    };
};
export default useCustomHjelpetekstById;
